<template>
  <div class="form-field" :class="{ 'form-field--error': !!errorMessage, success: meta.valid }">
    <label class="form-field__label" :for="name">{{ props.label }}</label>
    <BaseInputDate v-model="inputValue" :test-id="testId" :max-date="maxDate" :min-date="minDate" />
    <p v-show="errorMessage" class="form-field__error">{{ errorMessage }}</p>
    <BaseIcon v-if="errorMessage" class="form-field__icon" type="warning" size="18" name="error" />
  </div>
</template>

<script lang="ts" setup>
  import { useField } from 'vee-validate'

  import BaseIcon from '@/components/BaseIcon.vue'
  import BaseInputDate from '@/components/BaseInputDate.vue'

  const props = defineProps({
    forceFocus: {
      default: false,
      type: Boolean,
    },
    label: {
      required: true,
      type: String,
    },
    maxDate: {
      required: false,
      type: Date,
    },
    minDate: {
      required: false,
      type: Date,
    },
    name: {
      required: true,
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    testId: {
      required: true,
      type: String,
    },
    value: {
      type: String,
    },
  })

  const {
    value: inputValue,
    errorMessage,
    meta,
  } = useField<string>(() => props.name, undefined, {
    label: props.label,
  })
</script>
<style>
  .form-field--error {
    .dp--input {
      color: #e00000;
      border-color: #e00000;
    }

    .dp--input::placeholder {
      color: #e00000;
      border-color: #e00000;
    }

    .dp--input:focus {
      background: #fff;
    }
  }

  .form-field {
    /* stylelint-disable-next-line no-descending-specificity */
    .dp--input {
      width: 100%;
      height: 32px;
      padding: 0 34px 0 12px;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      color: var(--color-primary-text);
      text-align: left;
      letter-spacing: -0.006em;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-shadow: 1px 2px 2px 0 #0000001f inset;
    }

    .dp--input:focus {
      background: var(--color-main-10);
      border-color: var(--color-main-100);
    }

    .dp--input:hover {
      border-color: var(--color-main-100);
    }
  }
</style>
